(() => {
  if (window.JaEvoMath) return;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const validEmployeeCount = (count) => Number.isInteger(count) && count >= 10 && count <= 500 && count % 5 === 0;
  const annual = (employees, rates) => {
    if (!Number.isInteger(employees) || employees < 10 || employees > 500) return null;
    const rate = rates[employees <= 70 ? 0 : employees <= 150 ? 1 : 2];
    if (!Number.isFinite(rate) || rate < 0) return null;
    return Math.round(employees * rate);
  };
  const matchAnnualVariant = ({ variants, employees, cost, enabled, currency, cartCurrency, requiresPlan }) => {
    if (!enabled || requiresPlan || currency !== cartCurrency || !validEmployeeCount(employees) || !Number.isFinite(cost)) return null;
    const matches = variants.filter(variant => {
      const count = /^(\d+)(?:\s+employees?)?$/i.exec(String(variant.option1 || '').trim());
      return variant.available && variant.price === cost && count && Number(count[1]) === employees &&
        !variant.option2 && !variant.option3 &&
        (!variant.quantity_rule || (variant.quantity_rule.min <= 1 && variant.quantity_rule.increment === 1 &&
          (variant.quantity_rule.max == null || variant.quantity_rule.max >= 1)));
    });
    return matches.length === 1 ? matches[0] : null;
  };
  const lostTime = ({ employees, wage, minutes, workingDays, daysPerWeek, period }) => {
    const days = { daily: 1, weekly: daysPerWeek, monthly: workingDays / 12, yearly: workingDays }[period] ?? workingDays;
    const hours = employees * minutes / 60 * days;
    return { hours, cost: hours * wage };
  };
  const money = (currency) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency }); }
    catch { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }); }
  };
  window.JaEvoMath = Object.freeze({ clamp, annual, validEmployeeCount, matchAnnualVariant, lostTime, money });
})();
